import { makeAutoObservable } from 'mobx'

export const DEFAULT_DATE_FORMAT = 'dd/MM/yyyy'
export const DEFAULT_TIME_ZONE = 'America/Caracas'

class RegionalSettingsStore {
  dateFormat = DEFAULT_DATE_FORMAT
  timeZoneId = DEFAULT_TIME_ZONE

  constructor() {
    makeAutoObservable(this)
  }

  setPreferences(settings?: { DateFormat?: string; TimeZoneId?: string } | null) {
    this.dateFormat = settings?.DateFormat || DEFAULT_DATE_FORMAT
    this.timeZoneId = settings?.TimeZoneId || DEFAULT_TIME_ZONE
  }

  reset() {
    this.dateFormat = DEFAULT_DATE_FORMAT
    this.timeZoneId = DEFAULT_TIME_ZONE
  }
}

export default new RegionalSettingsStore()
